import { render } from "./BaseMainNavBtn.vue?vue&type=template&id=210f72b1"
import script from "./BaseMainNavBtn.vue?vue&type=script&lang=js"
export * from "./BaseMainNavBtn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__